import { Box, Drawer, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MainMenu } from 'src/components/MainMenu';
import { useAppDispatch, useAppSelector } from '~/application/hooks';
import { selectIsDrawerOpen, setDrawerOpen } from '~/application/slice';
import { MainDrawerHeader } from './MainDrawerHeader';

type MainDrawerProps = {
    window?: () => Window;
};

export const MainDrawer = ({ window }: MainDrawerProps) => {
    const drawerOpen = useAppSelector(selectIsDrawerOpen);
    const dispatch = useAppDispatch();

    const downLG = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const container = window !== undefined ? () => window().document.body : undefined;

    // noinspection JSUnusedGlobalSymbols
    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1200 }}>
            <MainDrawerRoot
                variant={!downLG ? 'permanent' : 'temporary'}
                open={drawerOpen}
                {...(downLG && {
                    container,
                    onClose: () => dispatch(setDrawerOpen(false)),
                    ModalProps: { keepMounted: true },
                    sx: { display: { xs: 'block', lg: 'none' } }
                })}
            >
                <MainDrawerHeader open={drawerOpen} />
                <MainMenu />
            </MainDrawerRoot>
        </Box>
    );
};

const MainDrawerRoot = styled(Drawer, {})(
    ({ open, theme }) => ({
        width: open ? 260 : 60,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        '& .MuiDrawer-paper': {
            width: open ? 260 : 60,
            overflowX: 'hidden',
            borderRight: `1px solid ${theme.palette.divider}`,
            boxShadow: 'none',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: open
                    ? theme.transitions.duration.enteringScreen
                    : theme.transitions.duration.leavingScreen,
            }),
        },
    })
);
